import { styled as i, Box as k, Typography as y } from "@mui/material";
import { DownloadStatus as O } from "../constants/download.js";
import v from "../../temp-lib/components/share/apeiron/ApeironLinkButton.js";
import p from "../../temp-lib/components/share/next/Image.js";
import { DEFAULT_ANIMATE_DURATION as l } from "../../temp-lib/constants/layout.js";
import T from "../../temp-lib/hooks/analytics/useGoogleTagManager.js";
import * as t from "ramda";
import { useCallback as A } from "react";
import { jsx as e, jsxs as c, Fragment as I } from "react/jsx-runtime";
const E = i(v)`
  align-items: center;
  background-color: #000000aa;
  border-radius: 10px;
  border: 2px solid #ffffffcc;
  gap: 12px;
  justify-content: center;
  min-height: 50px;
  padding: 7px 15px 7px 15px;
  transition: background-color ${l}ms,
    transform ${l}ms;
  ${(r) => r.theme.breakpoints.up("res1024")} {
    width: 220px;
  }
  ${(r) => r.theme.breakpoints.down("res1024")} {
    max-width: 180px;
    width: 45%;
  }

  &.Mui-disabled {
    opacity: 1;
  }
  :hover {
    background-color: #00000077;
    transform: translateY(-2px);
  }
`, S = i(k)`
  display: flex;
  flex-direction: column;
  height: 100%;
`, B = i(p)`
  aspect-ratio: 1;
  height: 34px;
  filter: invert(1);
`, C = i(y)`
  align-items: flex-start;
  color: white;
  display: flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  strong {
    font-size: 18px;
    font-weight: 700;
    line-height: 18px;
  }
`, D = i(p)`
  filter: invert(1);
  height: 100%;
  width: 100%;
`, R = (r) => {
  const {
    analytic: n,
    info: o
  } = r, {
    gtmEmitEvent: a
  } = T(), m = A(() => {
    if (t.has("event", n) && t.has("value", n)) {
      const {
        event: w,
        value: s
      } = n;
      t.isEmpty(s) || a(w, {
        value: s
      });
    }
  }, [n, a]), d = t.propOr("", "status", o) === O.ComingSoon, f = t.pathOr("", ["build", "url"], o), h = t.pathOr("", ["platform", "icon", "normal"], o), g = t.pathOr("", ["platform", "icon", "long"], o), x = t.pathOr("", ["platform", "name"], o), u = t.propOr("", "statusText", o), b = t.propOr(!1, "imageOnly", o);
  return /* @__PURE__ */ e(E, {
    disabled: d,
    url: f,
    target: "_blank",
    onClick: m,
    ...t.is(String, n) ? {
      id: n
    } : {},
    children: b ? /* @__PURE__ */ e(D, {
      src: g
    }) : /* @__PURE__ */ c(I, {
      children: [/* @__PURE__ */ e(B, {
        src: h
      }), /* @__PURE__ */ e(S, {
        children: /* @__PURE__ */ c(C, {
          children: [u, /* @__PURE__ */ e("strong", {
            children: x
          })]
        })
      })]
    })
  });
};
export {
  R as default
};
//# sourceMappingURL=DownloadButton.js.map
